{
  "entities": {
    "warehouses": "Armazém | Armazéns",
    "loadtypes": "Tipo de Carga | Tipos de Carga",
    "organizations": "Organização | Organizações",
    "orgs": "Org | Orgs"
  }
}
